(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var RC = window.RC || {};

  function money(cents) {
    var v = cents / 100;
    var whole = Math.round(v) === v;
    try {
      return new Intl.NumberFormat(RC.locale || 'en-IN', {
        style: 'currency', currency: RC.currency || 'INR',
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2
      }).format(v);
    } catch (e) { return '₹' + v.toFixed(whole ? 0 : 2); }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-show');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2400);
  }

  /* ---------- drawers ---------- */
  function drawer(sel) { return $(sel); }
  function openD(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  function closeD(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  function openCart() { openD(drawer('[data-cart-drawer]')); }
  function closeCart() { closeD(drawer('[data-cart-drawer]')); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart],[data-close-cart],[data-open-menu],[data-close-menu],[data-open-search],[data-close-search],[data-open-filters],[data-close-filters],[data-line-qty],[data-open-acc]');
    if (!t) return;
    if (t.hasAttribute('data-open-cart')) { e.preventDefault(); openCart(); }
    else if (t.hasAttribute('data-close-cart')) closeCart();
    else if (t.hasAttribute('data-open-menu')) openD(drawer('[data-menu-drawer]'));
    else if (t.hasAttribute('data-close-menu')) closeD(drawer('[data-menu-drawer]'));
    else if (t.hasAttribute('data-open-search')) { var p = $('[data-search-panel]'); p.hidden = false; var i = $('input[type=search]', p); i && i.focus(); }
    else if (t.hasAttribute('data-close-search')) $('[data-search-panel]').hidden = true;
    else if (t.hasAttribute('data-open-filters')) $('[data-filters]').classList.add('is-open');
    else if (t.hasAttribute('data-close-filters')) $('[data-filters]').classList.remove('is-open');
    else if (t.hasAttribute('data-line-qty')) changeLine(+t.getAttribute('data-line-qty'), +t.getAttribute('data-qty'));
    else if (t.hasAttribute('data-open-acc')) {
      var d = document.getElementById(t.getAttribute('data-open-acc'));
      if (d && d.tagName === 'DETAILS') { e.preventDefault(); d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeD(drawer('[data-menu-drawer]')); var p = $('[data-search-panel]'); if (p) p.hidden = true; }
  });

  /* ---------- countdown ---------- */
  function tick() {
    $$('[data-countdown]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(end)) { el.closest('.announce__timer').style.display = 'none'; return; }
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (s === 0) { el.closest('.announce__timer').style.display = 'none'; return; }
      var h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      el.textContent = String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
    });
    $$('[data-countdown-boxes]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-countdown-boxes')).getTime();
      if (isNaN(end)) return;
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var set = function (k, v) { var n = $('[data-' + k + ']', el); if (n) n.textContent = String(v).padStart(2, '0'); };
      set('d', Math.floor(s / 86400)); set('h', Math.floor(s % 86400 / 3600)); set('m', Math.floor(s % 3600 / 60)); set('s', s % 60);
    });
  }
  if ($('[data-countdown],[data-countdown-boxes]')) { tick(); setInterval(tick, 1000); }

  /* ---------- carousel ---------- */
  $$('[data-carousel]').forEach(function (c) {
    var track = $('[data-track]', c);
    var step = function () { var it = track.firstElementChild; return it ? it.getBoundingClientRect().width + 16 : 300; };
    var p = $('[data-prev]', c), n = $('[data-next]', c);
    p && p.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    n && n.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
  });

  /* ---------- cart ---------- */
  function updateCartBar(cart) {
    var bar = $('[data-cartbar]'); if (!bar) return;
    var need = +bar.getAttribute('data-qty'), reward = bar.getAttribute('data-reward');
    var have = cart.item_count, left = Math.max(0, need - have);
    $('[data-cartbar-fill]', bar).style.width = Math.min(100, have / need * 100) + '%';
    $('[data-cartbar-msg]', bar).innerHTML = left === 0
      ? 'You unlocked <b>' + esc(reward) + '</b>!'
      : 'Add <b>' + left + '</b> more item' + (left > 1 ? 's' : '') + ' to get <b>' + esc(reward) + '</b>';
    bar.classList.toggle('is-done', left === 0);
  }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    $$('[data-cart-count-inline]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
    var body = $('[data-cart-items]'), foot = $('[data-cart-foot]');
    if (body) {
      if (!cart.items.length) {
        body.innerHTML = '<div class="cart-empty"><p>Your cart is empty</p><a class="btn" href="/collections/all">Continue shopping</a></div>';
      } else {
        body.innerHTML = cart.items.map(function (it, i) {
          var idx = i + 1;
          return '<div class="line"><a class="line__img" href="' + it.url + '">' +
            (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="80" height="100">' : '') + '</a>' +
            '<div class="line__info"><a class="line__title" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
            (it.variant_title ? '<span class="line__var">' + esc(it.variant_title) + '</span>' : '') +
            '<span class="line__price">' + money(it.final_line_price) + '</span>' +
            '<div class="qty qty--small"><button type="button" data-line-qty="' + idx + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease">&minus;</button><span>' + it.quantity + '</span><button type="button" data-line-qty="' + idx + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
            '<button class="line__remove" type="button" data-line-qty="' + idx + '" data-qty="0" aria-label="Remove">&times;</button></div>';
        }).join('');
      }
    }
    if (foot) { foot.hidden = !cart.items.length; var st = $('[data-cart-subtotal]'); if (st) st.textContent = money(cart.total_price); }
    updateCartBar(cart);
  }
  function refreshCart() { return fetch(RC.routes.cartJson).then(function (r) { return r.json(); }).then(renderCart); }
  function changeLine(line, qty) {
    return fetch(RC.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  function addToCart(form) {
    var btn = $('[type=submit]', form), err = $('[data-form-error]', form);
    if (err) err.hidden = true;
    if (btn) btn.disabled = true;
    return fetch(RC.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { var msg = res.j.description || res.j.message || 'Could not add to cart'; if (err) { err.textContent = msg; err.hidden = false; } else toast(msg); return; }
        return refreshCart().then(openCart);
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.disabled = false; });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-add-form]');
    if (f) { e.preventDefault(); addToCart(f); }
  });
  if ($('[data-cartbar]')) refreshCart();

  /* ---------- collection ---------- */
  var sort = $('[data-sort-select]');
  if (sort) sort.addEventListener('change', function () { sort.form.submit(); });

  /* ---------- product ---------- */
  var pdp = $('[data-product]');
  if (pdp) {
    var variants = JSON.parse($('[data-variants]', pdp).textContent);
    var form = $('#product-form');
    var idInput = $('[data-variant-id]', pdp);
    var atc = $('[data-atc]', pdp), atcLabel = $('[data-atc-label]', pdp);
    var priceWrap = $('[data-price-wrap]', pdp);
    var sticky = $('[data-sticky-atc]'), stickyPrice = $('[data-sticky-price]'), stickyBtn = $('[data-sticky-btn]');

    function selected() {
      return $$('[data-option]', pdp).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function priceHTML(v) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var off = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        return '<div class="price price--sale"><span class="price__sale">' + money(v.price) + '</span><s class="price__regular">' + money(v.compare_at_price) + '</s><span class="price__off">' + off + '% off</span></div>';
      }
      return '<div class="price"><span class="price__regular-only">' + money(v.price) + '</span></div>';
    }
    function update() {
      var sel = selected();
      $$('[data-option]', pdp).forEach(function (fs, i) { var l = $('[data-opt-label]', fs); if (l) l.textContent = sel[i] || ''; });
      var v = variants.filter(function (x) { return sel.every(function (s, i) { return s === null || x['option' + (i + 1)] === s; }); })[0];
      if (!v) { atc.disabled = true; atcLabel.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      priceWrap.innerHTML = priceHTML(v);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      atc.disabled = !v.available; atcLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if (history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
      if (v.featured_image) {
        var all = $$('[data-slide]', pdp);
        var pos = (v.featured_media && v.featured_media.position) ? v.featured_media.position - 1 : -1;
        if (pos >= 0 && all[pos]) show(pos);
      }
    }
    $$('[data-option] input', pdp).forEach(function (i) { i.addEventListener('change', update); });
    // mark sold-out size pills
    $$('[data-option]', pdp).forEach(function (fs, oi) {
      if ($$('[data-option]', pdp).length !== 1) return;
      $$('input', fs).forEach(function (inp) {
        var v = variants.filter(function (x) { return x['option' + (oi + 1)] === inp.value; })[0];
        if (v && !v.available) { var lb = fs.querySelector('label[for="' + inp.id + '"]'); lb && lb.classList.add('is-soldout'); }
      });
    });

    var qi = $('[data-qty-input]', pdp);
    $('[data-qty-minus]', pdp) && $('[data-qty-minus]', pdp).addEventListener('click', function () { qi.value = Math.max(1, (+qi.value || 1) - 1); });
    $('[data-qty-plus]', pdp) && $('[data-qty-plus]', pdp).addEventListener('click', function () { qi.value = (+qi.value || 1) + 1; });

    /* gallery */
    var slides = $$('[data-slide]', pdp), dots = $$('[data-dot]', pdp), thumbs = $$('[data-thumb]', pdp), cur = 0;
    function show(n) {
      if (!slides.length) return;
      cur = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === cur); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === cur); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === cur); });
    }
    $('[data-gprev]', pdp) && $('[data-gprev]', pdp).addEventListener('click', function () { show(cur - 1); });
    $('[data-gnext]', pdp) && $('[data-gnext]', pdp).addEventListener('click', function () { show(cur + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(+d.getAttribute('data-dot')); }); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.getAttribute('data-thumb')); }); });
    var gm = $('.gallery__main', pdp), sx = 0;
    if (gm) {
      gm.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      gm.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); });
    }

    /* sticky add to cart (mobile) */
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { threshold: 0 }).observe(atc);
      stickyBtn && stickyBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }

    /* recommendations */
    var recs = $('[data-recs]');
    if (recs) {
      fetch(recs.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var s = $('.recs', d); if (s) recs.innerHTML = s.outerHTML;
      }).catch(function () {});
    }
  }
})();
